import { Record } from 'immutable';

export default class PricePeriodRecord extends Record({
  id: undefined,
  date: undefined,
  deviation: undefined,
  fee: undefined,
  from: undefined,
  minutes: undefined,
  to: undefined,
  total: undefined,
}) {
}
